import { render, staticRenderFns } from "./DurationForm.vue?vue&type=template&id=689f1472&scoped=true"
import script from "./DurationForm.vue?vue&type=script&lang=js"
export * from "./DurationForm.vue?vue&type=script&lang=js"
import style0 from "./DurationForm.vue?vue&type=style&index=0&id=689f1472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689f1472",
  null
  
)

export default component.exports